module.exports = __webpack_public_path__ + "img/floor8.007ec347.jpg";